import { FC } from "react";
import styles from "./TeamCard.module.scss";
import {
  HeadersOptionsType,
  TeamGridOptionsType,
} from "@/types/ModuleOptionsType";
import ModalRoot from "../_primitives/Modal/ModalRoot/ModalRoot";
import ModalPortal from "../_primitives/Modal/ModalPortal/ModalPortal";
import ModalOverlay from "../_primitives/Modal/ModalOverlay/ModalOverlay";
import ModalContent from "../_primitives/Modal/ModalContent/ModalContent";
import { TeamModalContent } from "../TeamModalContent/TeamModalContent";
import { OptionsSocialMediaType } from "@/types/OptionType";
import { ModalClose } from "../_primitives/Modal/ModalClose/ModalClose";
import { Post } from "@aleksundshantu/schirdewan-standard-types/client";
import { useTeamCard } from "./useTeamCard";
import { Modul_Mitarbeiter_Grid } from "@/wp/types/acf-module-types";
import { MediaItem } from "../MediaItem/MediaItem";
import { customSanitize } from "@/utils/customSanitize";

export type TeamCardElementType = {
  element: Post<"team">["acf"]["header_team"];
  url: string;
};

interface TeamCardProps {
  team: TeamCardElementType;
  gridOptions: TeamGridOptionsType;
  socialMedia: OptionsSocialMediaType;
  teamheaderOptions: HeadersOptionsType["header_team"];
  headlineTag: Modul_Mitarbeiter_Grid["team_grid"]["headline_html_tag"];
  skeleton: boolean;
}

export const TeamCard: FC<TeamCardProps> = ({
  team,
  gridOptions,
  socialMedia,
  teamheaderOptions,
  headlineTag,
  skeleton,
}) => {
  const { element } = team;
  const {
    grid_options: { grid_type, team_item_view },
    media_format,
  } = gridOptions;
  const { cardClassName, LinkJSX, NameJSX, link, wrapInButtonForPopUp } =
    useTeamCard(gridOptions, team, headlineTag, skeleton);

  const isTitleInImage = grid_type === "title-in-image";
  const isSingleViewOrPopUp =
    team_item_view === "single-view" || team_item_view === "pop-up";

  const skeletonElementClass = skeleton ? "skeleton-element" : "";

  const CardJSX = (
    <article className={cardClassName}>
      {wrapInButtonForPopUp(
        <MediaItem
          className={`${skeletonElementClass}`}
          image_desktop={element.image}
          mediaFormat={media_format}
          sizes="(max-width: 767px) 90vw, (max-width: 1024px) 50vw, (max-width: 1215px) 33vw, 320px"
          copyrightPosition={grid_type === "title-in-image" ? "top" : "bottom"}
          link={
            team_item_view === "single-view" && element.has_single_page
              ? link
              : undefined
          }
        />,
      )}

      {isTitleInImage ? (
        <>
          {isSingleViewOrPopUp && LinkJSX}
          <div className={styles["abs-wrapper"]}>{NameJSX}</div>
        </>
      ) : (
        <div className={styles["team-card-content"]}>
          <div>
            {NameJSX}
            <p
              className={`${styles["position"]} ${skeletonElementClass}`}
              dangerouslySetInnerHTML={{
                __html: customSanitize(element.position),
              }}
            >
              {/* {element.position} */}
            </p>
          </div>
          {isSingleViewOrPopUp && LinkJSX}
        </div>
      )}
    </article>
  );

  if (team_item_view === "single-view") return CardJSX;

  return (
    <ModalRoot>
      {CardJSX}
      <ModalPortal>
        <ModalOverlay />
        <ModalContent className={styles["team-modal"]}>
          <ModalClose></ModalClose>
          <TeamModalContent
            team={team}
            socialMedia={socialMedia}
            teamheaderOptions={teamheaderOptions}
          />
        </ModalContent>
      </ModalPortal>
    </ModalRoot>
  );
};
